"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AccessControlUpgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _AccessControlUpgradeable__factory.AccessControlUpgradeable__factory;
  }
});
Object.defineProperty(exports, "OwnableUpgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _OwnableUpgradeable__factory.OwnableUpgradeable__factory;
  }
});
var _AccessControlUpgradeable__factory = require("./AccessControlUpgradeable__factory");
var _OwnableUpgradeable__factory = require("./OwnableUpgradeable__factory");